var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "c-login" }, [
    _c("main", { staticClass: "description" }, [
      _vm.$slots.default
        ? _c("section", { staticClass: "content" }, [_vm._t("default")], 2)
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "aside",
      { staticClass: "form" },
      [
        _c("header", { staticClass: "header" }, [
          _vm.title
            ? _c("h1", [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")])
            : _vm._e(),
          _vm._v(" "),
          _vm.subtitle
            ? _c("p", [
                _vm._v("\n        " + _vm._s(_vm.subtitle) + "\n      ")
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "c-form",
          { staticClass: "form", on: { submit: _vm.submit } },
          [
            _c("c-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|email",
                  expression: "'required|email'"
                }
              ],
              staticClass: "field",
              attrs: {
                disabled: _vm.isSubmitting,
                type: "email",
                name: "E-mail",
                label: "E-mail",
                placeholder: "Ex. rodrigo@convenia.com.br",
                "feedback-type": _vm.errors.has("E-mail") ? "error" : null,
                "feedback-message": _vm.errors.has("E-mail")
                  ? "E-mail inválido"
                  : null,
                "feedback-show": _vm.errors.has("E-Mail")
              },
              model: {
                value: _vm.email,
                callback: function($$v) {
                  _vm.email = $$v
                },
                expression: "email"
              }
            }),
            _vm._v(" "),
            _c("c-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "field",
              attrs: {
                disabled: _vm.isSubmitting,
                type: "password",
                name: "Senha",
                label: "Senha",
                placeholder: "Ex. ••••••••",
                "feedback-type": _vm.errors.has("Senha") ? "error" : null,
                "feedback-message": _vm.errors.has("Senha")
                  ? "Senha inválida"
                  : null,
                "feedback-show": _vm.errors.has("Senha")
              },
              model: {
                value: _vm.password,
                callback: function($$v) {
                  _vm.password = $$v
                },
                expression: "password"
              }
            }),
            _vm._v(" "),
            _c(
              "c-button",
              {
                staticClass: "login-button",
                attrs: {
                  slot: "actions",
                  type: "submit",
                  disabled: _vm.isSubmitting
                },
                slot: "actions"
              },
              [
                _vm.isSubmitting
                  ? _c("c-spinner", { attrs: { size: "sm" } })
                  : _c("span", [_vm._v("Entrar")])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2596fd12", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2596fd12","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/convenia-components/CLogin.vue
// module id = L95L
// module chunks = 1624